import Banner from "../assets/images/FAQ-Banner.png";
import MobileBanner from "../assets/images/FAQ_Mobile.jpg";
import FaqSideImage from "../assets/images/FAQ Side Image.png";
import "./Faqs.css";

import React, { useState } from "react";

function FAQPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
        question: "What are the benefits of Himalayan cheese chews?",
        answer: "Himalayan cheese chews, also known as Himalayan dog chews, are popular among pet owners for several reasons: Natural Ingredients: These chews are typically made from yak or cow milk, salt, and a small amount of lime juice. Long-lasting chews: Himalayan cheese chews are hard and dense, making them long-lasting compared to some other types of dog chews.",
    },
    {
      question: "Where can I buy Himalayan cheese chews?",
      answer:
        "Himalayan Cheese Chews available at Petntreats.com. Natural dog treats available for sale online at Petntreats. Himalayan cheese chews on specific websites like PetNTreats. However, you can visit the PetNTreats website directly and search for the product in their inventory. If they offer online purchasing, you should be able to find Himalayan cheese chews in their pet treat section.",
    },
    {
      question: "What do I do if the chew is too hard for my dog?",
      answer:
        "If your dog finds it too hard to chew on, you can dip the bar in hot water for around 5-10 minutes. Dry out the chew and leave it for an hour before giving it to your dog.",
    },
    {
      question: "How do I store the chew once opened?",
      answer:
        "Make sure the chew is fully dry before storing. Store in a cool, dry, and ventilated area away from heat sources. Avoid any contact with water or moisture for prolonged periods. Exposure to water might attract mold and make the chew lose its shape and stiffness.",
    },
    {
      question:
        "What are the feeding recommendations for these Himalayan Dog Chews?",
      answer:
        "Our dog chews are categorized as treats and must not be substituted for meals. We recommend giving 2-3 chews in a week, and more if your dog is a voracious chewer. Always provide adequate fresh drinking water to compensate for the lack of moisture in the treat.",
    },
    {
      question: "Is milk good for dogs?",
      answer:
        "Milk in its raw form is difficult for dogs to digest but once the milk is processed and hardened into Himalayan Dog Chew, it is easily digestible. Lactose and whey protein is removed in Himalayan Dog Chew manufacturing process. As most dogs are lactose intolerant, low lactose content less than 0.5% is not harmful to them.",
    },
    {
      question: "Do you sell chews without label or in a private label?",
      answer:
        "Yes, we do sell chews in bulk as per the wholesaler’s requirement.",
    },
    {
      question: "How should we store bulk chews?",
      answer:
        "Keep the chews in a cool and dry place. Avoid direct sunlight and contact with water or moisture. Do not store bulk chews in the refrigerator as it will cause the hard cheese to crack. Properly seal the chews and store them at dry and normal temperature. Avoid plastic and uncoated metal containers.",
    },
    {
      question: "Are salt and fat not bad for dogs?",
      answer:
        "Our chew contains less than 1% of fat as most of the fat and cream is extracted during the production phase. Salt is harmful for dogs only if it is consumed in large amounts. Rock Salt is used for brine washing the chews. Salt is not used for coagulation of milk. Whey/lime or natural citric acid is used to coagulate the milk.",
    },
  ];

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="min-vh-100" style={{ backgroundColor: "#A3BCD3" }}>
      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"
        rel="stylesheet"
      />

      <div className="container-fluid">
        <div className="row min-vh-100">
          {/* Left Side - Image */}
          <div className="col-lg-5 d-flex align-items-center justify-content-center p-0">
            <div
              className="w-100 h-100 d-flex align-items-center justify-content-center"
              style={{ backgroundColor: "#A3BCD3" }}
            >
              <div className="text-center" style={{ fontSize: "120px" }}>
                <img className="pt-5 side-image" src={FaqSideImage} alt=""></img>
              </div>
            </div>
          </div>

          {/* Right Side - FAQ */}
          <div className="col-lg-7 d-flex align-items-center py-5 px-4 px-lg-5">
            <div className="w-100">
              {/* FAQ Title */}
              <div className="mb-5">
                <h1
                  className="display-1 fw-bold text-white mb-4"
                  style={{
                    fontFamily: "'Brush Script MT'",
                    fontSize: "clamp(4rem, 10vw, 8rem)",
                    letterSpacing: "5px",
                  }}
                >
                  FAQ
                </h1>
              </div>

              {/* FAQ Accordion */}
              <div className="accordion-flush">
                {faqs.map((faq, index) => (
                  <div key={index} className="mb-3">
                    <div
                      className="d-flex justify-content-between align-items-center py-3 px-2"
                      style={{
                        cursor: "pointer",
                        borderBottom: "1px solid rgba(255, 255, 255, 0.3)",
                        transition: "all 0.3s ease",
                      }}
                      onClick={() => toggleAccordion(index)}
                    >
                      <h5
                        className="text-white mb-0"
                        style={{
                          fontSize: "1.1rem",
                          fontWeight: "400",
                          flex: 1,
                        }}
                      >
                        {faq.question}
                      </h5>
                      <span
                        className="text-white ms-3"
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "300",
                          transition: "transform 0.3s ease",
                          transform:
                            openIndex === index
                              ? "rotate(45deg)"
                              : "rotate(0deg)",
                        }}
                      >
                        +
                      </span>
                    </div>

                    {/* Accordion Content */}
                    <div
                      style={{
                        maxHeight: openIndex === index ? "300px" : "0",
                        overflow: "hidden",
                        transition: "max-height 0.4s ease",
                        opacity: openIndex === index ? 1 : 0,
                      }}
                    >
                      <div className="py-3 px-2">
                        <p
                          className="text-white mb-0"
                          style={{
                            fontSize: "0.95rem",
                            lineHeight: "1.6",
                            opacity: "0.9",
                          }}
                        >
                          {faq.answer}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600&display=swap');
        
        body {
          font-family: 'Poppins', sans-serif;
        }
        
        .accordion-flush > div:hover {
          background-color: rgba(255, 255, 255, 0.05);
        }
      `}</style>
    </div>
  );
}

const Faqs = () => {
  return (
    <>
      <div style={{ fontFamily: "Arial, sans-serif", overflowX: "hidden" }}>
        {/* Banner Section - Starts from absolute top */}
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "800px",
            overflow: "hidden",
          }}
        >
          <img
            src={Banner}
            alt="Banner"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center",
              display: "block",
            }}
            className="desktop-banner"
          />
          <img
            src={MobileBanner}
            alt="Banner"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center",
              display: "none",
            }}
            className="mobile-banner"
          />
          <style>{`
            @media (max-width: 768px) {
              .desktop-banner {
                display: none !important;
              }
              .mobile-banner {
                display: block !important;
              }
            }
          `}</style>
        </div>
      </div>
      <FAQPage />
    </>
  );
};

export default Faqs;
